import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import PropTypes from 'prop-types';
import { triggerErrorCode } from 'redux/actions/errorsActions';


const Errors = props => (
  <ul>
    <li>
      <button onClick={() => props.triggerErrorCode(400)}>400</button>
      <button onClick={() => props.triggerErrorCode(401)}>401</button>
      <button onClick={() => props.triggerErrorCode(403)}>403</button>
      <button onClick={() => props.triggerErrorCode(404)}>404</button>
      <button onClick={() => props.triggerErrorCode(500)}>500</button>
    </li>
  </ul>
);

Errors.propTypes = {
  triggerErrorCode: PropTypes.func.isRequired,
};

export default compose(connect(
  null,
  { triggerErrorCode },
))(Errors);
